<template>
  <div class="main-page-wrapper">
    <static-pages-header @mobileMenuToggle="mobileMenuToggle"/>

    <section class="heading-container" :class="{'heading-container-mobile-menu-open': isMobileMenuOpen}">
      <div class="heading-block">
        <div class="heading">
          {{ $t('message.mainPage.heading.title') }}
        </div>
        <!--
        <div class="heading-desc">
          {{ $t('message.mainPage.heading.desc.textStart') }}
          <router-link to="/documents" class="heading-link">
            {{ $t('message.mainPage.heading.desc.link') }}
          </router-link>
          {{ $t('message.mainPage.heading.desc.textEnd') }}
        </div>
        -->
        <div class="heading-desc">
          {{ $t('message.mainPage.heading.desc.text') }}
        </div>
        <div class="heading-btn-block">
          <base-button
            :text="$t('message.mainPage.heading.btn')"
            @click="signUp()"
            v-if="!isAuthorized"
          />
        </div>
      </div>
      <img class="heading-img" src="../../public/custom/images/main-page/heading-img.png" alt="Heading-img">
    </section>

    <section class="offers-container" v-if="!isLoading">
      <div class="offers-title">{{ $t('message.mainPage.offers.title') }}</div>
      <div class="filters-block">
        <div class="filter-item">
          <base-text-input
            :label="$t('message.mainPage.offers.filters.amount.title')"
            :placeholder="filterAmountPlaceholderFrom"
            :name="'min-amount'"
            :mask-pattern="'####'"
            v-model="filters.loan_amount_min"
            :default-value="filters.loan_amount_min"
            :isHasErrorBlock="false"
          />
          <base-text-input
            :placeholder="filterAmountPlaceholderTo"
            :name="'min-amount'"
            :mask-pattern="'####'"
            v-model="filters.loan_amount_max"
            :default-value="filters.loan_amount_max"
            :isHasErrorBlock="false"
          />
        </div>
        

        <div class="filter-item">
          <base-text-input
            :label="$t('message.mainPage.offers.filters.terms.title')"
            :placeholder="filterTermsPlaceholderFrom"
            :name="'min-amount'"
            :mask-pattern="'##'"
            v-model="filters.loan_term_days_min"
            :default-value="filters.loan_term_days_min"
            :isHasErrorBlock="false"
          />
          <base-text-input
            :placeholder="filterTermsPlaceholderTo"
            :name="'min-amount'"
            :mask-pattern="'##'"
            v-model="filters.loan_term_days_max"
            :default-value="filters.loan_term_days_max"
            :isHasErrorBlock="false"
          />
        </div>

        <div class="filter-item">
          <base-text-input
            :label="$t('message.mainPage.offers.filters.rating.title')"
            :placeholder="filterRatingPlaceholderFrom"
            :name="'min-amount'"
            :mask-pattern="'###'"
            v-model="filters.rating_min"
            :default-value="filters.rating_min"
            :isHasErrorBlock="false"
          />
          <base-text-input
            :placeholder="filterRatingPlaceholderTo"
            :name="'min-amount'"
            :mask-pattern="'###'"
            v-model="filters.rating_max"
            :default-value="filters.rating_max"
            :isHasErrorBlock="false"
          />
        </div>

        <div class="filter-item">
          <base-button
            :text="$t('message.mainPage.offers.filters.resetBtn')"
            @click="resetFilters()"
            class="filter-btn filter-reset-btn"
            :minHeight="'40px'"
          />
          <base-button
            :text="$t('message.mainPage.offers.filters.applyBtn')"
            @click="applyFilters()"
            class="filter-btn"
            :minHeight="'40px'"
          />
        </div>
        <div
          v-if="isBorrower"
          class="filter-available"
          @click.stop="toggleShowAvailableLoans()"
        >
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': filters.available_for_me }"
          >
            <img
              v-if="filters.available_for_me"
              class="check-box-image"
              src="../../public/custom/images/check.svg"
              alt="Checked image"
            />
          </div>
          <div class="check-box-label">
            {{ $t('message.mainPage.offers.filters.showAvailable') }}
          </div>
        </div>
      </div>
      <div class="offers-block">
        <div class="title-item">
          <div class="offer-img"></div>
          <div class="offer-item-amount">{{ $t('message.mainPage.offers.tableTitle.amount') }}</div>
          <div class="offer-item-return">{{ $t('message.mainPage.offers.tableTitle.return') }}</div>
          <div class="offer-issued-by">{{ $t('message.mainPage.offers.tableTitle.issuedBy') }}</div>
          <div class="offer-rating">{{ $t('message.mainPage.offers.tableTitle.rating') }}</div>
          <div class="offer-btn-block"></div>
        </div>
        <div class="title-item">
          <div class="offer-img"></div>
          <div class="offer-item-amount">{{ $t('message.mainPage.offers.tableTitle.amount') }}</div>
          <div class="offer-item-return">{{ $t('message.mainPage.offers.tableTitle.return') }}</div>
          <div class="offer-issued-by">{{ $t('message.mainPage.offers.tableTitle.issuedBy') }}</div>
          <div class="offer-rating">{{ $t('message.mainPage.offers.tableTitle.rating') }}</div>
          <div class="offer-btn-block"></div>
        </div>
        <offer-item
          v-for="item of fullOffersList"
          :key="item.id"
          :item="item"
          :profile="profile"
        />
      </div>
      <div class="more-offers-block" v-if="isHasMoreOffers">
        <div class="more-offers-block-btn-block">
          <base-button
            :text="$t('message.mainPage.offers.more')"
            @click="updateOffersList()"
          />
        </div> 
      </div>
    </section>

    <div class="offer-notice">
      <p class="offer-notice-text" v-html="$t('message.mainPage.offers.notice')">
      </p>
    </div>

    <section class="diploma-container">
      <div class="diploma-content">
        <h3 class="diploma-title">
          {{ $t('message.mainPage.diploma.title') }}
        </h3>
        <p class="diploma-desc">
          {{ $t('message.mainPage.diploma.desc') }}
        </p>
        <div class="diploma-image-wrapper">
          <img
            class="diploma-image"
            src="/static/diploma.png"
            :alt="$t('message.mainPage.diploma.alt')"
          />
        </div>
      </div>
    </section>

    <section class="hiw-container">
      <div class="hiw-block">
        <div class="hiw-data">
          <div class="hiw-data-title">{{ $t('message.mainPage.hiw.title') }}</div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">1</div>
              <span>{{ $t('message.mainPage.hiw.first.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.mainPage.hiw.first.desc') }}
            </div>
          </div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">2</div>
              <span>{{ $t('message.mainPage.hiw.second.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.mainPage.hiw.second.desc') }}
            </div>
          </div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">3</div>
              <span>{{ $t('message.mainPage.hiw.third.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.mainPage.hiw.third.desc') }}
            </div>
          </div>
        </div>
        <img class="hiw-image" src="../../public/custom/images/main-page/hiw-image.png" alt="Men image">
      </div>
    </section>

    <section class="advantages-container">
      <div class="advantages-title">{{ $t('message.mainPage.advantages.title') }}</div>
      <div class="advantages-block">
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/Bank.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.first') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/time.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.second') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/7.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.third') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/security.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.preFourth') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/ssl.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.fourth') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/rating.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.fifth') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../public/custom/images/main-page/advantages/judge.svg" alt="Advantage image">
          </div>
          <div class="advantages-item-desc">{{ $t('message.mainPage.advantages.items.sixth') }}</div>
        </div>
      </div>
    </section>

    <!-- <section class="loans">
      <section class="target-loans-container">
        <div class="target-loans-title">
          {{ $t('message.mainPage.targetLoans.title') }}
        </div>
        <div class="target-loans-block">
          <div class="targets-loan-item" v-for="item of targetLoansList" :key="item.title">
            <img class="target-loans-img" :src="require(`../../public/custom/images/main-page/target-loans/${item.img}.svg`)" alt="Target loans image">
            <div class="targets-loan-item-title">
              {{ $t(`message.mainPage.targetLoans.${item.title}`) }}
            </div>
            <div class="targets-loan-item-data">
              <div class="loan-data-item">
                <span>{{ $t('message.mainPage.targetLoans.amount') }}</span>
                <span class="loan-data-item-number">{{ item.numbers.first }} BYN</span>
              </div>
              <div class="loan-data-item">
                <span>{{ $t('message.mainPage.targetLoans.time') }}</span>
                <span class="loan-data-item-number">{{ item.numbers.second }} {{ $t('message.mainPage.targetLoans.days') }}</span>
              </div>
              <div class="loan-data-item">
                <span>{{ $t('message.mainPage.targetLoans.amount') }}</span>
                <span class="loan-data-item-number">{{ item.numbers.third }} BYN</span>
              </div>
            </div>
            <div class="targets-loan-item-btn-block">
              <base-button
                :text="$t('message.mainPage.targetLoans.btn')"
              />
            </div>
          </div>
        </div>
      </section>
      <section class="new-loan-container">
        <div class="new-loan-block">
          <div class="new-loan-title">{{ $t('message.mainPage.newLoan.title') }}</div>
          <div class="new-loan-desc">{{ $t('message.mainPage.newLoan.descFirstRow') }}</div>
          <div class="new-loan-desc">{{ $t('message.mainPage.newLoan.descSecondRow') }}</div>
        </div>
        <img class="new-loan-img" src="../../public/custom/images/main-page/new-loan-image.png" alt="New loan image">
      </section>
    </section> -->

    <!-- <section class="partners-container">
      <div class="partners-title">{{ $t('message.mainPage.partners.title') }}</div>
      <div class="bottom-partners-block">
        <img src="../../public/custom/images/main-page/partners/national-bank.png" alt="National bank image">
        <img src="../../public/custom/images/main-page/partners/ramo.png" alt="Ramo image">
        <img src="../../public/custom/images/main-page/partners/paritet.png" alt="Paritet image">
        <div class="bepaid-partner">
          <img class="bepaid-img" src="../../public/custom/images/main-page/partners/bepaid.svg" alt="Bepaid image">
        </div>
        <img src="../../public/custom/images/main-page/partners/msi.png" alt="Msi image">
        <img src="../../public/custom/images/main-page/partners/elportal.png" alt="Electronic portal image">
      </div>
    </section> -->

    <section class="operator-container">
      <h3 class="operator-title">
        {{ $t('message.mainPage.operator.title') }}
      </h3>
      <div class="operator-data">
        <p class="operator-item">
          {{ $t('message.mainPage.operator.first') }}
        </p>
        <p class="operator-item">
          {{ $t('message.mainPage.operator.second') }}
        </p>
        <p class="operator-item">
          {{ $t('message.mainPage.operator.third') }}
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import BaseButton from '../components/base/BaseButton.vue';
import { mapGetters } from 'vuex';
import offerItem from './Main/offerItem.vue';
import StaticPagesHeader from '../components/common/StaticPagesHeader.vue';
import BaseTextInput from '../components/base/BaseTextInput.vue';

export default {
  name: 'Main',
  inject: ['$httpService'],
  components: {
    BaseButton,
    offerItem,
    StaticPagesHeader,
    BaseTextInput
  },
  async created() {
    try {
      await this.$store.dispatch('getOffersList', this.getOffersParams());
      this.fullOffersList = [...this.offersList];
    } catch (error) {
      console.log(error);
    }
    this.isLoading = false;
  },
  data() {
    return {
      page: 0,
      fullOffersList: [],
      targetLoansList: [
        {
          title: 'first',
          numbers: {
            first: 100,
            second: 7,
            third: 125
          },
          img: 'pig'
        },
        {
          title: 'second',
          numbers: {
            first: 250,
            second: 10,
            third: 300
          },
          img: 'calendar'
        },
        {
          title: 'third',
          numbers: {
            first: 300,
            second: 30,
            third: 400
          },
          img: 'universal'
        },
        {
          title: 'fourth',
          numbers: {
            first: 700,
            second: 14,
            third: 850
          },
          img: 'bags'
        },
        {
          title: 'fifth',
          numbers: {
            first: 450,
            second: 21,
            third: 550
          },
          img: 'repair'
        },
        {
          title: 'sixth',
          numbers: {
            first: 750,
            second: 45,
            third: 1000
          },
          img: 'vocations'
        }
      ],
      isLoading: true,
      isMobileMenuOpen: false,
      isOfferBtnLoading: false,
      filters: {
        status: 'published',
        available_for_me: true,
        loan_amount_min: undefined,
        loan_amount_max: undefined,
        loan_term_days_min: undefined,
        loan_term_days_max: undefined,
        rating_min: undefined,
        rating_max: undefined,
      },
    }
  },
  methods: {
    signUp() {
      this.$router.push({ name: 'msi' });
    },
    async signOut() {
      await localStorage.removeItem('token');
      await this.$store.dispatch('purgeProfile');
    },
    mobileMenuToggle(value) {
      this.isMobileMenuOpen = value;
    },
    getOffersParams() {
      const params = { ...this.filters, page: this.page };

      if (!this.isBorrower) {
        delete params.available_for_me;
      }

      return params;
    },
    async updateOffersList() {
      this.page = ++this.page;
      await this.$store.dispatch('updateOffersList', this.getOffersParams());
      this.fullOffersList = [...this.fullOffersList, ...this.offersList];
    },
    async toggleShowAvailableLoans() {
      this.filters.available_for_me = !this.filters.available_for_me;
      await this.applyFilters();
    },
    async resetFilters() {
      this.page = 0;

      this.filters = {
        status: 'published',
        available_for_me: true,
        loan_amount_min: undefined,
        loan_amount_max: undefined,
        loan_term_days_min: undefined,
        loan_term_days_max: undefined,
        rating_min: undefined,
        rating_max: undefined,
      };

      try {
        await this.$store.dispatch('getOffersList', this.getOffersParams());
        this.fullOffersList = [...this.offersList];
      } catch (error) {
        console.log(error);
      }
    },
    async applyFilters() {
      this.page = 0;

      try {
        await this.$store.dispatch('getOffersList', this.getOffersParams());
        this.fullOffersList = [...this.offersList];
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    ...mapGetters(['profile', 'offersList', 'isHasMoreOffers']),
    isAuthorized() {
      return this.profile?.role;
    },
    isBorrower() {
      return this.profile?.role === 'borrower';
    },
    parsedUserName() {
      if (this.isAuthorized) {
        return this.profile.name_ru?.given_name_ru.slice(0, 1) + this.profile.name_ru?.family_name_ru.slice(0, 1);
      } else {
        return '';
      }
    },
    filterAmountPlaceholderFrom() {
      const minAmount = window.entityCabinetSettings.offer.minAmount;
      return `${this.$t('message.mainPage.offers.filters.from')} ${minAmount}`;
    },
    filterAmountPlaceholderTo() {
      const minAmount = window.entityCabinetSettings.offer.maxAmount;
      return `${this.$t('message.mainPage.offers.filters.to')} ${minAmount}`;
    },
    filterTermsPlaceholderFrom() {
      const minAmount = window.entityCabinetSettings.offer.minTerm;
      return `${this.$t('message.mainPage.offers.filters.from')} ${minAmount}`;
    },
    filterTermsPlaceholderTo() {
      // const minAmount = window.entityCabinetSettings.offer.maxTerm;
      const minAmount = '90';
      return `${this.$t('message.mainPage.offers.filters.to')} ${minAmount} ${this.$t('message.mainPage.offers.filters.days')}`;
    },
    filterRatingPlaceholderFrom() {
      const minAmount = 1;
      return `${this.$t('message.mainPage.offers.filters.from')} ${minAmount}`;
    },
    filterRatingPlaceholderTo() {
      const minAmount = 100;
      return `${this.$t('message.mainPage.offers.filters.to')} ${minAmount}`;
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-page-wrapper {
    @include base-page-wrapper;
  }

  .header-menu-open {
    position: fixed;
    top: 0;
    left: 0;
  }

  .header-container {
    @include base-page-container;

    margin-bottom: 11px;
    height: 74px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  .heading-container-mobile-menu-open {
    margin-top: 85px;
  }

  .mobile-menu-container {
    position: fixed;
    height: 100vh;
    width: calc(100vw);
    padding-top: 40px;
    padding-left: 10px;
    box-sizing: border-box;
    top: 74px;
    left: calc(100vw + 700px);
    display: flex;
    flex-direction: column;
    background-color: #F8F8F8;
    transition: left .2s ease-in-out;
    z-index: 1000;
  }

  .mobile-nav-block {
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;

    .nav-item {
      margin-bottom: 20px;
      font-weight: 600;
      font-size: 16px;
      line-height: 135%;
      color: #121212;
    }
  }

  .mobile-authorization-block {
    display: flex;
    flex-direction: column;

    .sign-in-block,
    .sign-out-block {
      margin-left: 0;
      margin-bottom: 25px;
    }

    .reg-btn {
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
    }
  }

  .mobile-menu-container-open {
    left: 0;
  }

  .bottom-line {
    @include base-page-container;

    max-width: 100%;
    height: 2px;
    border-radius: 3px;
    background-color: #ECEEF0;
  }

  .header-block {
    @include base-page-container;

    height: 100%;
    max-width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .nav-block {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .logo {
    margin-right: 55px;
  }

  .nav {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .nav-item {
    padding-right: calc(20px + 12 * (100vw / 1920));
    font-weight: 600;
    font-size: calc(14px + 4 * (100vw / 1920));
    line-height: 25px;
    color: #121212;
    cursor: pointer;
  }

  .authorization-block {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .profile-img {
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F49332;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: white;
    border-radius: 50%;
    cursor: pointer;
  }

  .sign-in-block,
  .sign-out-block {
    margin-left: 20px;
    width: 104px;
    height: 38px;
  }

  .mobile-menu-open-img {
    display: none;
  }

  .heading-container {
    width: 100%;
    margin-bottom: 75px;
    padding: 0px 95px 0px 140px;
    box-sizing: border-box;
    background-color: #FDFAF1;
    display: flex;
    justify-content: space-between;
  }

  .heading-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .heading {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: calc(20px + 30 * (100vw / 1920));
    line-height: calc(24px + 37 * (100vw / 1920));
    color: #121212;
  }

  .heading-desc {
    margin-bottom: 60px;
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #3D3F42;
    width: 95%;
    white-space: pre-line;
  }

  .heading-link {
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #41BF7B;
    text-decoration: none;
  }

  .heading-btn-block {
    width: 300px;
    height: 65px;
  }

  .heading-img {
    max-width: 60%;
    max-height: 500px;
    margin-right: 5%;
  }

  .hiw-container,
  .target-loans-container {
    @include base-page-container;

    padding: 0 202px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }

  .offers-container {
    @include base-page-container;

    margin-bottom: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .filters-block {
    width: 100%;
    margin-bottom: 1.25rem;
    border-radius: .5rem;
    background-color: #f8f8f8;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    padding: .75rem;
  }

  .filter-available {
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .check-box-btn {
    @include base-check-box;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .check-box-image {
    width: 12px;
  }

  .check-box-label {
    @include base-check-box-label;
    width: auto;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }

  .filter-item {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
    align-items: end;
    row-gap: .25rem;
  }

  .filter-btn {
    margin-bottom: 10px;
    height: 50px;
    min-height: 50px;
    width: 146px;
  }

  .filter-reset-btn {
    @include secondary-btn;
    width: 146px;
  }

  .offers-block {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 60px;
  }

  .more-offers-block {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .more-offers-block-btn-block {
    width: 275px;
    max-width: 95%;
    height: 60px;
  }

  .offer-item,
  .title-item {
    padding-bottom: 13px;
    box-sizing: border-box;
    height: 62px;
    width: calc(50% - 30px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom:  1px solid #ECEEF0;
    font-weight: 400;
    font-size: 18px;
    line-height: 135%;
    color: #121212;
  }

  .title-item {
    border: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #878787;
  }

  .offer-img {
    height: 30px;
    width: 30px;
    margin-right: 8px;
  }

  .offer-item-amount {
    width: 13%;
    margin-right: 4px;
  }

  .offer-item-return {
    width: 15%;
    margin-right: 4px;
  }

  .offer-issued-by {
    width: 12%;
    margin-right: 4px;
  }

  .offer-rating {
    width: 13%;
    margin-right: 4px;
  }

  .offer-btn-block {
    width: 170px;
    height: 36px;
  }

  .offer-btn ::v-deep {
    padding: 0;
    box-sizing: border-box;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #41BF7B;
    background-color: white;
    border: 2px solid #41BF7B;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #41BF7B;
      color: white;
    }
  }

  .offer-btn-loading ::v-deep {
    &:hover {
      color: #41BF7B;
    background-color: white;
    }
  }

  .mobile-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #878787;
    white-space: nowrap;
  }

  .offer-amount-block-mobile,
  .offer-return-block-mobile,
  .offer-issued-block-mobile,
  .offer-rating-block-mobile {
    width: 100%;
    margin-bottom: 8px;
    display: none;
    justify-content: space-between;
    align-items: flex-end;
  }

  .offer-amount-block-mobile {
    margin-top: 15px;

    .offer-item-amount {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-return-block-mobile {
    .offer-item-return {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-issued-block-mobile {
    .offer-issued-by {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-rating-block-mobile {
    margin-bottom: 15px;
    .offer-rating {
      width: inherit;
      display: block;
      text-align: end;
      font-size: 16px;
    }
  }

  .offer-btn-block-mobile {
    height: 50px;
    width: 100%;
    display: none;
  }

  .offer-notice {
    width: 100%;
    max-width: 95%;
    display: flex;
    justify-content: center;
    margin-bottom: 84px;
  }

  .offer-notice-text {
    text-align: center;
    font-size: 1rem;
    line-height: 1.5rem;
    color: rgba(0,0,0,.561);
  }

  .hiw-block {
    width: 100%;
    max-height: 550px;
    margin-bottom: 140px;
    display: flex;
    justify-content: space-between;
  }

  .hiw-data {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .hiw-item {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .hiw-image {
    height: 525px;
  }

  .hiw-item-number {
    height: 37px;
    width: 37px;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #41BF7B;
    color: white;
  }

  .hiw-item-title {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: calc(20px + 6 * (100vw / 1920));
    line-height: 35px;
    color: #121212;
  }

  .hiw-desc {
    margin-left: 57px;
    font-weight: 400;
    font-size: calc(16px + 2 * (100vw / 1920));
    line-height: 135%;
    color: #474747;
  }

  .loans {
    width: 100%;
    padding-top: 70px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F8F8F8;;
  }

  .target-loans-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .target-loans-block {
    width: 100%;
    margin-bottom: 140px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .targets-loan-item {
    width: 398px;
    height: 460px;
    padding-top: 40px;
    margin-bottom: 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    box-shadow: 2px 2px 30px rgba(177, 179, 182, 0.2);
    border-radius: 20px;
    background-color: white;
  }

  .target-loans-img {
    position: absolute;
    top: 110px;
    left: 49px;
    z-index: 1;
  }

  .targets-loan-item-title {
    margin-bottom: 41px;
    font-weight: 500;
    font-size: 32px;
    line-height: 39px;
    letter-spacing: 0.01em;
    color: #121212;
  }

  .targets-loan-item-data {
    margin-bottom: 132px;
    width: 202px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
  }

  .loan-data-item {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    line-height: 130%;
    color: #878787;

    .loan-data-item-number {
      color: #474747;
      font-weight: 600;
    }
  }

  .targets-loan-item-btn-block {
    width: 250px;
    height: 60px;
    position: relative;
    z-index: 2;
  }

  .new-loan-container {
    @include base-page-container;

    margin-bottom: 70px;
    padding-left: 146px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(180deg, #FFDED8 0%, #FFDCD8 51.14%, #FFDCD8 100%);
    border-radius: 20px;
  }

  .new-loan-block {
    display: flex;
    flex-direction: column;
  }

  .new-loan-title {
    margin-bottom: 25px;
    text-align: start !important;
  }

  .new-loan-desc {
    font-weight: 400;
    font-size: 22px;
    line-height: 130%;
    color: #474747;
  }

  .new-loan-desc:last-child {
    margin-bottom: 60px;
  }

  .new-loan-img {
    border-radius: 20px;
  }

  .advantages-container {
    @include base-page-container;

    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .offers-title,
  .advantages-title,
  .partners-title,
  .hiw-data-title,
  .target-loans-title,
  .new-loan-title {
    font-weight: 700;
    font-size: calc(24px + 16 * (100vw / 1920));;
    line-height: 125%;
    color: #121212;
    text-align: center;
  }

  .hiw-data-title {
    text-align: start;
  }

  .advantages-title,
  .target-loans-title,
  .offers-title {
    margin-bottom: 50px;
  }

  .offers-title {
    text-align: center;
  }

  .advantages-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }

  .advantages-item {
    padding: 40px;
    gap: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 2px 30px rgba(177, 179, 182, 0.2);
    border-radius: 20px;
  }

  .advantages-item:nth-child(-n + 4) {
    flex: 1 1 calc(25% - 20px);
  }

  .advantages-item:not(:nth-child(-n + 4)) {
    flex: 1 1 calc(33% - 20px);
  }

  .advantages-item-img-block {
    width: 84px;
    height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
    }
  }

  .advantages-item-desc {
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 400;
  }

  .partners-container {
    @include base-page-container;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .partners-title {
    margin-bottom: 54px;
  }

  .partners-block {
    width: 100%;
    margin-bottom: 70px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .partner-img {
    max-width: 550px;
    max-height: 340px;
    width: 32%;
    border-radius: 20px;
  }

  .bottom-partners-block {
    width: 100%;
    margin-bottom: 50px;
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 1rem;

    img:not(.bepaid-img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    img {
      max-width: 100%;
    }
  }

  .bepaid-img {
    height: 50px;  
  }

  .bepaid-partner {
    padding: .5rem;
    box-sizing: border-box;
    background-color: #f8f8f8;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .reg-btn {
    font-weight: 600;
    font-size: calc(14px + 4 * (100vw / 1920));
    line-height: 25px;
    color: #41BF7B;
    cursor: pointer;
  }

  .operator-container {
    @include base-page-container;

    display: flex;
    flex-direction: column;
    gap: 48px;
    margin: 124px 0 0 0;
  }

  .operator-title {
    all: unset;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 600;
  }

  .operator-data {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: .25rem;
  }

  .operator-item {
    all: unset;
    font-size: .875rem;
    line-height: 1.25rem;
  }

  .diploma-container {
    @include base-page-container;

    margin: 0px 0 116px 0;
    padding: 72px 48px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #fdfaf1 0%, #ffffff 100%);
    border-radius: 24px;
    box-shadow:
      0 2px 8px rgba(18, 18, 18, 0.04),
      0 12px 40px rgba(18, 18, 18, 0.08),
      0 24px 64px rgba(65, 191, 123, 0.08);
  }

  .diploma-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    text-align: center;
  }

  .diploma-title {
    all: unset;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 600;
    color: #121212;
  }

  .diploma-desc {
    all: unset;
    max-width: 760px;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #3d3f42;
  }

  .diploma-image-wrapper {
    width: 100%;
    max-width: 920px;
    margin-top: 12px;
    padding: 28px;
    box-sizing: border-box;
    border-radius: 24px;
    background-color: #ffffff;
    box-shadow: 0 16px 48px rgba(18, 18, 18, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .diploma-image-wrapper:hover {
    transform: translateY(-4px);
    box-shadow: 0 24px 56px rgba(18, 18, 18, 0.12);
  }

  .diploma-image {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
  }

  @media screen and (max-width: 1610px) {
    .hiw-container,
    .target-loans-container {
      padding: 0 5%;
    } 
  }

  @media screen and (max-width: 1770px) {
    .advantages-container,
    .partners-container {
      width: 1400px;
    }

    .advantages-item-img-block {
      width: 54px;
      height: 54px;
    }

    .bottom-partners-block {
      img {
        width: 249px;
      }
    }
  }

  @media screen and (max-width: 1750px) {
    .advantages-container {
      margin-bottom: 10px;
    }
    .advantages-block {
      justify-content: space-evenly;
    }
    .advantages-item {
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 1530px) {
    .heading-desc {
      br {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1450px) {
    .heading-container {
      padding: 0px 2.5% 0px 2.5%;
    }

    .heading-img {
      max-height: 450px;
      margin-right: 10%;
    }
  }

  @media screen and (max-width: 1400px) {
    .advantages-item-desc {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }

  @media screen and (max-width: 1320px) {
    .advantages-block {
      justify-content: space-evenly;
    }
  }

  @media screen and (max-width: 1300px) {
    .heading-img {
      margin-right: 0;
    }

    .hiw-container {
      padding: 0;
    }

    .hiw-image {
      object-fit: contain;
      height: 480px;
    }

    .hiw-data-title {
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: 1250px) {

    .title-item {
      display: none;
    }
    .offer-item {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: auto;
    }

    .offer-img,
    .offer-item-amount,
    .offer-item-return,
    .offer-issued-by,
    .offer-rating,
    .offer-btn-block {
      display: none;
    } 

    .offer-amount-block-mobile,
    .offer-return-block-mobile,
    .offer-issued-block-mobile,
    .offer-rating-block-mobile {
      display: flex;
    }

    .offer-btn-block-mobile {
      display: block;
    }

    .filters-block {
      display: grid;
      row-gap: .75rem;
      -moz-column-gap: 60px;
      column-gap: 60px;
      grid-template-columns: 1fr 1fr;
    }

    .filter-available {
      grid-column: 1 / -1;
    }

    .filter-btn {
      width: 100%;
    }
  }

  @media screen and (max-width: 1150px) {
    .advantages-item {
      padding: 20px;
      min-width: 250px;
    }

    .nav {
      display: none;
    }

    .authorization-block {
      display: none;
    }

    .mobile-menu-open-img {
      display: block;
      cursor: pointer;
    } 
  }

  @media screen and (max-width: 1060px) {
    .bottom-partners-block {
      width: auto;
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    .bepaid-partner {
      height: 163px;
    }

    .heading-desc {
      width: 100%;
    }

    .hiw-image {
      height: 270px;
    }
  }

  @media screen and (max-width: 890px) {
    .heading-container {
      padding-top: 70px;
      padding-bottom: 30px;
      flex-direction: column;
      align-items: center;
    }

    .heading-block {
      align-items: center;
      margin-bottom: 40px;
    }

    .heading {
      text-align: center;
    }

    .hiw-block {
      max-height: fit-content;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .hiw-data {
      width: 100%;
      margin-bottom: 40px;
    }

    .hiw-data-title {
      margin-bottom: 30px;
    }

    .hiw-item {
      margin-bottom: 25px;
    }

    .hiw-item-title {
      flex-direction: column;
      align-items: flex-start;

      span {
        margin-bottom: 8px;
      }
    }

    .hiw-item-number {
      margin-bottom: 10px;
    }

    .hiw-desc {
      margin-left: 0;
    }

    .hiw-image {
      width: 90%;
      height: auto;
    }

    .diploma-container {
      margin: 56px 0 80px 0;
      padding: 48px 24px;
      border-radius: 16px;
      box-shadow:
        0 2px 6px rgba(18, 18, 18, 0.04),
        0 8px 24px rgba(18, 18, 18, 0.08);
    }

    .diploma-title {
      font-size: 1.25rem;
      line-height: 1.75rem;
    }

    .diploma-desc {
      font-size: .875rem;
      line-height: 1.25rem;
    }

    .diploma-image-wrapper {
      padding: 16px;
      border-radius: 16px;
    }
  }

  @media screen and (max-width: 790px) {
    .partners-block {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .partner-img {
      width: 100%;
      margin-bottom: 30px;
    }

    .paritet {
      order: 1;
    }

    .national-bank {
      order: 2;
    }

    .msi {
      order: 5;
    }

    .htp {
      order: 6;
    }

    .elportal {
      order: 3;
    }

    .bpc {
      order: 4;
    }

    .bottom-partners-block {
      img:not(.bepaid-img) {
        margin-bottom: 20px;
        border-radius: 20px;
        object-fit: contain;
      }
    }

    .filters-block {
      display: flex;
      flex-direction: column;
    }
  }

  @media screen and (max-width: 670px) {
    .heading {
      text-align: left;
    }
    .advantages-block {
      justify-content: space-between;
    }

    .bottom-partners-block {
      justify-content: center;
    }
  }

  @media screen and (max-width: 600px) {
    .offers-block {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .offer-item {
      width: 100%;
    }
  }
</style>